import React from "react";
import { Box, Stack, Spacer, Divider } from "digiwash-components";

function SkeletonPopularServices() {
  return (
    <Stack style={{ width: "100%", overflow: "hidden" }} px="xm">
      <Box
        br="s"
        bg="common.white"
        style={{
          width: 128,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box br="m" bg="gray.bg" style={{ width: 40, height: 6 }} />
        <Divider size="m" />
        <Box br="m" bg="gray.bg" style={{ width: 60, height: 4 }} />
      </Box>
      <Spacer size="xm" />
      <Box
        br="s"
        bg="common.white"
        style={{
          width: 128,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box br="m" bg="gray.bg" style={{ width: 40, height: 6 }} />
        <Divider size="m" />
        <Box br="m" bg="gray.bg" style={{ width: 60, height: 4 }} />
      </Box>
      <Spacer size="xm" />
      <Box
        br="s"
        bg="common.white"
        style={{
          width: 128,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box br="m" bg="gray.bg" style={{ width: 40, height: 6 }} />
        <Divider size="m" />
        <Box br="m" bg="gray.bg" style={{ width: 60, height: 4 }} />
      </Box>
      <Spacer size="xm" />
      <Box
        br="s"
        bg="common.white"
        style={{
          width: 128,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box br="m" bg="gray.bg" style={{ width: 40, height: 6 }} />
        <Divider size="m" />
        <Box br="m" bg="gray.bg" style={{ width: 60, height: 4 }} />
      </Box>
      <Spacer size="xm" />
      <Box
        br="s"
        bg="common.white"
        style={{
          width: 128,
          height: 60,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Box br="m" bg="gray.bg" style={{ width: 40, height: 6 }} />
        <Divider size="m" />
        <Box br="m" bg="gray.bg" style={{ width: 60, height: 4 }} />
      </Box>
    </Stack>
  );
}

export default SkeletonPopularServices;
